import { Modal } from "react-bootstrap";
import { useState } from "react";
import { EventItem, TypeBadge } from ".";
import {
  buildPermission,
  Resource,
  Action,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";

const DeleteConfirmModal: React.FC<{
  event: EventItem | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}> = ({ event, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  if (!event) return null;

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm();
    setLoading(false);
  };

  return (
    <Modal show={event !== null} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Confirmer la suppression</Modal.Title>
        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={onClose}
        >
          x
        </button>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div style={{ marginBottom: "1rem" }}>
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: "#fee2e2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              marginBottom: "1rem",
            }}
          >
            <i
              className="fa fa-trash"
              style={{ fontSize: "24px", color: "#ef4444" }}
            />
          </div>
        </div>
        <p
          style={{
            marginBottom: "0.5rem",
            color: "#475569",
            fontSize: "0.9rem",
          }}
        >
          Vous êtes sur le point de supprimer l'événement :
        </p>
        <p
          style={{
            fontWeight: 800,
            fontSize: "1rem",
            color: "#1e293b",
            marginBottom: "0.5rem",
          }}
        >
          « {event.title} »
        </p>
        <TypeBadge type={event.type} />
        <hr style={{ margin: "1rem 0" }} />
        <p
          style={{
            color: "#94a3b8",
            fontSize: "0.8rem",
            marginBottom: 0,
            display: "flex",
            alignItems: "flex-start",
            gap: "0.4rem",
            textAlign: "left",
            background: "#f8fafc",
            borderRadius: 10,
            padding: "0.75rem",
            border: "1px solid #f1f5f9",
          }}
        >
          <i className="fa fa-info-circle mt-1" style={{ flexShrink: 0 }} />
          Les cours annulés liés à cet événement seront restaurés si aucun autre
          événement n'est en conflit.
        </p>
      </Modal.Body>
      <Modal.Footer className="gap-2">
        <button
          type="button"
          className="btn btn-light"
          onClick={onClose}
          disabled={loading}
        >
          Annuler
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
              Suppression…
            </>
          ) : (
            <>
              <i className="fa fa-trash me-2" />
              Supprimer
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default withPermission(
  DeleteConfirmModal,
  [buildPermission(Resource.EVENT, Action.DELETE)],
  "masquer",
);
